import React from 'react';
import placeholderImage from 'assets/img/covers/placeholder.jpg';
import PropTypes from 'prop-types';
import * as Ui from './LocationImagesPreview.styles';

const LocationImagesPreview = ({ logo, coverImage, style }) => (
  <Ui.PreviewSection style={style}>
    <Ui.CoverImage imageUrl={coverImage || placeholderImage} />
    <Ui.LogoSection>
      <Ui.LogoContainer>
        <Ui.Logo src={logo} alt="" />
      </Ui.LogoContainer>
    </Ui.LogoSection>
  </Ui.PreviewSection>
);

LocationImagesPreview.propTypes = {
  logo: PropTypes.string,
  coverImage: PropTypes.string,
  style: PropTypes.object,
};

export default LocationImagesPreview;
